'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoChecklist = function GoChecklist(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.7 20.2l-1.9-2c-0.3-0.2-0.7-0.2-0.9 0l-4.1 4.1-4.7 4.7-3.7-3.6c-0.2-0.3-0.6-0.3-0.9 0l-1.9 1.9c-0.3 0.3-0.3 0.7 0 0.9l6 6.1c0.3 0.2 0.7 0.2 0.9 0l11.2-11.2c0.3-0.3 0.3-0.7 0-0.9z m-20.8 2.5l2-2c1.6-1.6 4.5-1.6 6.2 0l1 1 4.4-4.2v-12.5h-22.5v27.5h12.5l-3.6-3.6c-1.7-1.7-1.7-4.5 0-6.2z m-1.4-15.2h12.5v2.5h-12.5v-2.5z m0 5h12.5v2.5h-12.5v-2.5z m-2.5 7.5h-2.5v-2.5h2.5v2.5z m0-5h-2.5v-2.5h2.5v2.5z m0-5h-2.5v-2.5h2.5v2.5z m2.5 7.5h2.5v2.5h-2.5v-2.5z' })
        )
    );
};

exports.default = GoChecklist;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/checklist.js
// module id = 1642
// module chunks = 0